import React from "react";

import { Button } from "@perceptron/ui/components/button";
import { Dialog, DialogPortal } from "@perceptron/ui/components/dialog";
import { Icon } from "@perceptron/ui/components/icon";

import { ConnectedAnnotationEditor } from "./ConnectedAnnotationEditor";

interface ImageAnnotationDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  mediaSetId: string;
  currentImageIndex: number;
  onChangeImageIndex: (index: number) => void;
}

export function AnnotationDialog({
  isOpen,
  onOpenChange,
  mediaSetId,
  currentImageIndex,
  onChangeImageIndex,
}: ImageAnnotationDialogProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogPortal>
        {/* Backdrop (Note: high z-index to hide caret bubble; need to refactor z-index management)*/}
        <div className="fixed inset-0 z-[10001] bg-black/60" onClick={() => onOpenChange(false)} />

        {/* Content */}
        <div
          className="fixed inset-0 z-[10001] overflow-hidden rounded-lg border-8 border-[#171717] bg-[#171717] shadow-2xl sm:inset-[5vh]"
          onTouchEnd={(e) => e.stopPropagation()}
        >
          <ConnectedAnnotationEditor
            currentImageIndex={currentImageIndex}
            mediaSetId={mediaSetId}
            onNavigate={onChangeImageIndex}
          />

          {/* Close button - simple white X */}
          <Button
            aria-label="Close"
            className="absolute right-4 top-4 z-10 cursor-pointer rounded-full text-white opacity-60 transition-opacity hover:opacity-100"
            size="icon"
            variant="ghost"
            onClick={() => onOpenChange(false)}
          >
            <Icon className="h-5 w-5" name="x" />
          </Button>
        </div>
      </DialogPortal>
    </Dialog>
  );
}

export default AnnotationDialog;
